/**
 * Tasteful, map-inspired geographic graphic (not a real map).
 * Decorative — labeled via aria on the wrapper.
 */
export default function ServiceAreaMap({ className = "" }) {
  return (
    <div
      className={`relative overflow-hidden bg-gradient-to-br from-cream to-blush-soft border border-gold/25 ${className}`}
      style={{ aspectRatio: "5 / 4" }}
      role="img"
      aria-label="Map-inspired graphic highlighting Greensboro, North Carolina"
      data-testid="service-area-map"
    >
      <svg viewBox="0 0 500 400" className="absolute inset-0 h-full w-full" aria-hidden="true">
        <defs>
          <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M40 0 L0 0 0 40" fill="none" stroke="#C89B45" strokeWidth="0.5" opacity="0.18" />
          </pattern>
        </defs>
        <rect width="500" height="400" fill="url(#grid)" />
        {/* stylised roads */}
        <path d="M-10 120 C120 90 200 200 320 150 S480 210 520 180" fill="none" stroke="#C89B45" strokeWidth="1.4" opacity="0.5" />
        <path d="M60 -10 C90 120 40 240 130 300 S200 420 180 440" fill="none" stroke="#C89B45" strokeWidth="1.2" opacity="0.4" />
        <path d="M380 -10 C360 100 420 200 350 280 S300 400 330 440" fill="none" stroke="#C89B45" strokeWidth="1.2" opacity="0.4" />
        {/* surrounding markers */}
        {[
          [110, 110],
          [400, 130],
          [150, 300],
          [360, 300],
        ].map(([cx, cy], i) => (
          <circle key={i} cx={cx} cy={cy} r="4" fill="#D9B96E" opacity="0.7" />
        ))}
        {/* ripple around Greensboro */}
        <circle cx="250" cy="205" r="46" fill="none" stroke="#F4CCD7" strokeWidth="1.5" opacity="0.8" />
        <circle cx="250" cy="205" r="70" fill="none" stroke="#F4CCD7" strokeWidth="1" opacity="0.5" />
      </svg>

      {/* Greensboro pin */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-full flex flex-col items-center">
        <svg width="34" height="46" viewBox="0 0 34 46" aria-hidden="true">
          <path
            d="M17 45C17 45 32 27 32 16A15 15 0 1 0 2 16C2 27 17 45 17 45Z"
            fill="#080708"
            stroke="#C89B45"
            strokeWidth="1.2"
          />
          <circle cx="17" cy="16" r="5" fill="#D9B96E" />
        </svg>
      </div>
      <span className="absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-2 font-serif text-2xl text-ink">
        Greensboro
      </span>
    </div>
  );
}
